import { useDispatch } from "react-redux";
import { addTrailerVideo } from "../store/slices/moviesSlice";
import { useEffect, useCallback } from "react";
import { API_OPTIONS } from "../utils/constants";

const useMovieTrailer = (movieId: number | string) => {
  const dispatch = useDispatch();

  const getMovieVideos = useCallback(async () => {
    try {
      const data = await fetch(
        `https://api.themoviedb.org/3/movie/${movieId}/videos?language=en-US`,
        API_OPTIONS
      );
      const json = await data.json();

      if (!json.results) return;

      const filterData = json.results.filter((video: any) => video.type === "Trailer");
      const trailer = filterData.length ? filterData[0] : json.results[0];

      if (trailer) {
        dispatch(addTrailerVideo(trailer));
      }
    } catch (error) {
      console.error("Error fetching trailers:", error);
    }
  }, [movieId, dispatch]);

  useEffect(() => {
    getMovieVideos();
  }, [getMovieVideos]);
};

export default useMovieTrailer;
